import React, { useEffect, useState } from 'react'
import { makeStyles, Button, IconButton } from '@material-ui/core'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined, CalendarToday } from '@material-ui/icons'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'
import { gray } from '../../utils/colors'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		'& div': {
			display: 'flex'
		},
		gap: '1rem'
	},
	datePicker: {
		color: gray[100],
		opacity: 0,
		position: 'absolute',
		top: 0,
		margin: 0
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	filterButton: {
		zIndex: 1
	},
	calendarDateButton: {
		zIndex: 1,
		border: `1px solid ${gray[500]}`,
		padding: '.5rem 1.3rem',
		color: gray[800],
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: '1rem'
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: '2.375rem',
		width: '2.375rem',
		padding: '0.3125rem',
		'& svg': {
			height: '1rem'
		}
	}
}))

/**
 *
 * @param {{date: 'YYYY-MM-DD', onDateChanged: () => moment}} param0
 * @returns a moment object when date changes, if onDateChanged is provided
 */

const StyledToolbarDatePicker = ({ date, onDateChanged }) => {
	const classes = useStyles()

	const [calendarOpen, setCalendarOpen] = useState(false)
	const [internalDate, setInternalDate] = useState(date)

	useEffect(() => {
		setInternalDate(date)
	}, [date])

	const handleOnDateChanged = (date) => {
		setInternalDate(date)
		if (calendarOpen) {
			setCalendarOpen(false)
		}
		if (onDateChanged) {
			onDateChanged(date)
		}
	}

	const handleAddSubtractDate = (type) => {
		if (type === 'add') {
			handleOnDateChanged(moment(internalDate).add(1, 'd'))
		} else if (type === 'subtract') {
			handleOnDateChanged(moment(internalDate).subtract(1, 'd'))
		}
	}

	return (
		<div className={classes.root}>
			<div>
				<Button
					className={clsx(classes.headerButton, classes.calendarDateButton)}
					onClick={() => setCalendarOpen(true)}
					variant="outlined"
					endIcon={<CalendarToday style={{ height: 19, width: 19, fill: gray[700] }} />}
					classes={{
						label: classes.noWrap
					}}
					size="large">
					{moment(internalDate).format('MMM D, YYYY')}
				</Button>
				<KeyboardDatePicker
					disableToolbar
					open={calendarOpen}
					onOpen={() => setCalendarOpen(true)}
					onClose={() => setCalendarOpen(false)}
					variant="inline"
					format="MM/DD/YYYY"
					margin="normal"
					id="start-date"
					label="Start Date"
					inputVariant="filled"
					value={internalDate}
					onChange={handleOnDateChanged}
					className={classes.datePicker}
					rightArrowIcon={<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />}
					leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
					KeyboardButtonProps={{
						'aria-label': 'Start Date',
						className: classes.calendarButton
					}}
				/>
			</div>
			<div style={{ display: 'flex' }}>
				<IconButton
					className={classes.dateChangeButton}
					onClick={() => handleAddSubtractDate('subtract')}
					style={{ marginRight: '.5rem' }}>
					<ArrowBackIosOutlined style={{ fill: gray[700] }} />
				</IconButton>
				<IconButton className={classes.dateChangeButton} onClick={() => handleAddSubtractDate('add')}>
					<ArrowForwardIosOutlined style={{ fill: gray[700] }} />
				</IconButton>
			</div>
		</div>
	)
}

export default StyledToolbarDatePicker
